import React from "react";
import Header from "../Global/Header";
import WebsiteBreadCrumbs from "../Global/WebsiteBreadCrumbs";
import Womanimgthree from "./Womanimgthree";
import Exploreallsix from "../../Components/Explore/Exploreallsix";
import Footer from "../Global/Footer";
import CompanyLogo from "../Global/CompanyLogo";
import { useEffect } from "react";

function Womanimgthreemain() {
  useEffect(() => {
    document.title = "Executive Grace Office Wear | Crowd Approved Fashion";
  }, []);

  return (
    <div className="background-image body-color ">
      <Header />
      <WebsiteBreadCrumbs />
      <Womanimgthree />
      <Exploreallsix />
      <Footer />
      <CompanyLogo />
    </div>
  );
}

export default Womanimgthreemain;
